import { Typography, Dialog, useTheme } from '@mui/material';

import { AutomationList } from './AutomationList/AutomationList';
import { AutomationListVariant, AutomationModalPaneOptions } from './enums';
import { CreateAutomation } from './CreateAutomation/CreateAutomation';
import { ModalPaneContainer } from './styles';
import { ATSAutomationModalTestIds } from 'data-testids/ATS';
import { useAutomation } from './context/AutomationContext';
import { useEffect, useReducer } from 'react';
import { ACTION_TYPES, automationReducer } from './reducers/automationReducer';
import { useQueryGetAutomationsListData } from './api/listQueries';

export const AutomationModal: React.FC = () => {
  const theme = useTheme();
  const { currentPane, open, onClose, roleId } = useAutomation();
  const { data: automations } = useQueryGetAutomationsListData(roleId);

  const [automationState, automationDispatch] = useReducer(automationReducer, {
    automations: [],
    hasUnsavedChanges: false,
  });

  useEffect(() => {
    if (automations) {
      automationDispatch({
        type: ACTION_TYPES.SET_AUTOMATION_LIST,
        payload: { automations, hasUnsavedChanges: false },
      });
    }
  }, [automations]);

  const titleText =
    currentPane === AutomationModalPaneOptions.CREATE
      ? 'Create new auto-screen'
      : 'Automated pre-screen';

  return (
    <Dialog
      maxWidth={'md'}
      fullWidth
      data-testid={ATSAutomationModalTestIds.MODAL}
      onClose={onClose}
      open={open}
      sx={{
        '.MuiPaper-root': {
          borderRadius: theme.spacing(2),
          padding: 4,
        },
      }}
    >
      <Typography
        data-testid={ATSAutomationModalTestIds.HEADER_TEXT}
        color="black.dark"
        variant="h3"
      >
        {titleText}
      </Typography>
      <ModalPaneContainer>
        {currentPane === AutomationModalPaneOptions.CREATE && (
          <CreateAutomation
            automationState={automationState}
            automationDispatch={automationDispatch}
          />
        )}
        {currentPane === AutomationModalPaneOptions.LIST && (
          <AutomationList
            variant={AutomationListVariant.EDITABLE}
            automationState={automationState}
            automationDispatch={automationDispatch}
          />
        )}
      </ModalPaneContainer>
    </Dialog>
  );
};
